import { useEffect, useMemo, useState } from "react";
import { SortableTree } from "dnd-kit-sortable-tree";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { IconButton } from "../../uikit/HeaderV3/IconButton";
import type { BaseBlock } from "../DataModel.types";
import { SidebarHeader } from "../Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "../Sidebar/SidebarHeaderTitle";
import type { TreeItem } from "./LayersTreeItem";
import { LayersTreeItem } from "./LayersTreeItem";
import { convertBlocksToTree } from "./utils";

export const Layers = () => {
  const { closeSidebarView } = useBuilderStore(state => ({
    closeSidebarView: state.closeSidebarView,
  }));
  const root = useBuilderStore(state => state.getBlocks());
  const [items, setItems] = useState<TreeItem[]>([]);

  const rootChildren = useMemo(
    () =>
      Array.isArray(root?.props?.children?.value)
        ? (root.props.children.value as BaseBlock[])
        : [],
    [root?.props?.children?.value],
  );

  useEffect(() => {
    setItems(convertBlocksToTree(rootChildren));
  }, [rootChildren]);

  const handleItemsChange = (newItems: TreeItem[]) => {
    /* TODO: To be implemented */
    setItems(newItems);
  };

  return (
    <div className="divide-primary flex h-full w-[18rem] flex-col divide-y">
      <SidebarHeader>
        <div className="flex w-full items-center justify-between">
          <SidebarHeaderTitle>
            {t("builder_ui.layers.title")}
          </SidebarHeaderTitle>
          <IconButton
            name="24-close"
            iconSize={24}
            ariaLabel={t("close")}
            onClick={closeSidebarView}
          />
        </div>
      </SidebarHeader>

      <div className="flex h-full w-full flex-col overflow-hidden">
        <OverlayScrollbarsComponent>
          <ul className="py-2">
            <SortableTree
              items={items}
              onItemsChanged={handleItemsChange}
              TreeItemComponent={LayersTreeItem}
              indentationWidth={24}
              disableSorting // TODO: To be implemented
            />
          </ul>
        </OverlayScrollbarsComponent>
      </div>
    </div>
  );
};
